import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    topbar: {
      height: "10vh",
      display: "flex",
      justifyContent: "center",
    },
    titleTop: {
      width: "50vw",
      height: "19px",
      background:
        "linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 53%,rgba(255,255,255,0) 100%)",
      opacity: "0.2555",
      filter: "blur(0px)",
    },
    titleWrapper: {
      height: "9vh",
      width: "50vw",
      textAlign: "center",
      position: "relative",
      color: "white",
      background: "linear-gradient(180deg,rgba(47,76,173,1) 0%,#5FF6FF 100%)",
      borderRadius: "0px 0px 5vh 5vh",
    },
    title: {
      position: "absolute",
      width: "100%",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: "3vw",
    },
    titleBottom: {
      width: "100%",
      height: "3px",
      position: "absolute",
      bottom: 0,
      right: 0,
      background:
        "linear-gradient(142deg,rgba(255,255,255,0) 0%,rgba(54,192,255,1) 53%,rgba(255,255,255,0) 100%)",
      opacity: "0.7329000000000001",
      filter: "blur(0px)",
    },
  })
);

const Topbar = () => {
  const classes = useStyles();

  return (
    <div className={classes.topbar}>
      <div className={classes.titleWrapper}>
        <div className={classes.titleTop}></div>
        <div className={classes.title}>长三角化工行业产业地图</div>
        <div className={classes.titleBottom}></div>
      </div>
      <div></div>
    </div>
  );
};

export default Topbar;
